/**
* MapEntity Interface
*
* Generated file, don't touch manually
*
* ModelVersion: 90001
*/

export { MapEntity } from "@archipad-js/archipad-model";
